import * as R from 'ramda'
import { computed, type ComputedRef } from 'vue'

import {
  EventDetailId,
  EventStatusId,
  IncidentAttribute,
  IncidentId,
  SportDetails,
  SportIncident,
  SportStatus,
} from '@collector/sportsapi-client-legacy'

import { getIncidentAttributeIdToAttributeMap } from '../utils'
import { useSport } from './useSport'

type UseSportMaps = {
  eventDetailIdToSportDetailsMap: ComputedRef<
    Record<EventDetailId, SportDetails>
  >
  eventStatusToSportStatusMap: ComputedRef<Record<EventStatusId, SportStatus>>
  incidentAttributeIdToAttributeMap: ComputedRef<
    Record<IncidentAttribute['id'], IncidentAttribute>
  >
  incidentIdToSportIncidentMap: ComputedRef<Record<IncidentId, SportIncident>>
}

export function useSportMaps(): UseSportMaps {
  const { sport } = useSport()

  const incidentIdToSportIncidentMap = computed(() =>
    R.indexBy<SportIncident, IncidentId>(R.prop('id'), sport.value.incidents),
  )
  const eventStatusToSportStatusMap = computed(() =>
    R.indexBy<SportStatus, EventStatusId>(R.prop('id'), sport.value.statuses),
  )
  const eventDetailIdToSportDetailsMap = computed(() =>
    R.indexBy<SportDetails, EventDetailId>(R.prop('id'), sport.value.details),
  )
  const incidentAttributeIdToAttributeMap = computed(() =>
    getIncidentAttributeIdToAttributeMap(sport.value.incidents),
  )

  return {
    eventDetailIdToSportDetailsMap,
    eventStatusToSportStatusMap,
    incidentAttributeIdToAttributeMap,
    incidentIdToSportIncidentMap,
  }
}
